/* Use only the permanently pinned navigation height. Do not reserve the hidden upper header. */
(() => {
  const header = document.querySelector('header.header .header__bottom');
  if (!header) return;
  let previous = 0;
  const measure = () => {
    const top = Math.ceil(header.getBoundingClientRect().height) + 20;
    if (top === previous) return;
    previous = top;
    document.documentElement.style.setProperty('--palmera-info-sticky-top', top + 'px');
  };
  new ResizeObserver(measure).observe(header);
  measure();
})();
